// 校验字段是否填写状态
export const checkFiledRequire = function (obj, modulesItems) {
    const formData = JSON.parse(JSON.stringify(obj))
    const checkFiledObj = {
        flag: false,
        filed: '',
        message: ''
    }
    for (const prop in modulesItems) {
        const {key, placeholder, require, rules, label, show} = modulesItems[prop]
        const { rule, ruleMessage } = rules || {}
        formData[key] = formData[key] + ''
        let flag = true
        if (show === false) {
            continue
        }
        if (!formData[key] && require) {
            checkFiledObj.flag = true
            checkFiledObj.filed = key
            checkFiledObj.message = placeholder
            break
        }
        // 根据正则校验规则
        if (rule && formData[key] && !rule.test(formData[key])) {
            checkFiledObj.ruleFlag = true
            checkFiledObj.filed = key
            checkFiledObj.message = ruleMessage || placeholder
            flag = false
        }
        
        // 校验emoji
        if (flag && isEmoji(formData[key])) {
            checkFiledObj.ruleFlag = true
            checkFiledObj.filed = key
            checkFiledObj.message = `${label}不能输入特殊字符，请重新输入`
        }
    }
    return checkFiledObj
}

/**
 * 校验是否有emoji标签
 * @param {String} 字符串
 * @returns {Boolean} 是否有emoji表情
 */
export function isEmoji(substring) {
    for ( var i = 0; i < substring.length; i++) {
        var hs = substring.charCodeAt(i);
        if (0xd800 <= hs && hs <= 0xdbff) {
            if (substring.length > 1) {
                var ls = substring.charCodeAt(i + 1);
                var uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000;
                if (0x1d000 <= uc && uc <= 0x1f77f) {
                    return true;
                }
            }
        } else if (substring.length > 1) {
            var ls = substring.charCodeAt(i + 1);
            if (ls == 0x20e3) {
                return true;
            }
        } else {
            if (0x2100 <= hs && hs <= 0x27ff) {
                return true;
            } else if (0x2B05 <= hs && hs <= 0x2b07) {
                return true;
            } else if (0x2934 <= hs && hs <= 0x2935) {
                return true;
            } else if (0x3297 <= hs && hs <= 0x3299) {
                return true;
            } else if (hs == 0xa9 || hs == 0xae || hs == 0x303d || hs == 0x3030
                    || hs == 0x2b55 || hs == 0x2b1c || hs == 0x2b1b
                    || hs == 0x2b50) {
                return true;
            }
        }
    }
}

/**
 * 获取重定向地址
 * @param {String} appid 各个驾校公众号的APPID
 * @returns 返回重定向地址对象
 * 
 * wx2ba04a0746590bdf = 深港驾校
 * wxb65550f517b7f8e2 = 东莞广仁驾校
 */
export const getUrlInfo = function (appid = 'wx2ba04a0746590bdf') {
    // 根据域名获取环境变量 环境变量
    let envInfo = ''
    if (location.href.includes('app.coach.caronline.cn')) { // 生产
        envInfo = 'prod'
    } else if (location.href.includes('app.test.chelizitech.com')) { // 测试环境
        envInfo = 'uat'
    } else {
        envInfo = 'dev'
    }

    // 根据环境变量 获取url地址 appid
    const {originPath, appId} = {
        prod: {originPath: 'https://app.chetailian.com', appId: appid},
        uat: {originPath: 'https://uat.ctl.chelizitech.com', appId: 'wxd183626a0a4188f9'},
        dev: {originPath: 'https://dev.ctl.chelizitech.com', appId: 'wxd183626a0a4188f9'}
    }[envInfo]

    // 公众号跳转的地址
    const wxGzhPath = `${originPath}/ui/h5/preRepairOrderGzh/index?state=home-${appId}`
    // 重定向跳转的地址
    const redirectPath = `${originPath}/ui/h5/redirect?redirectUrl=${wxGzhPath}`

    return {
        wxGzhPath,
        redirectPath
    }
}